import { IAdFoxBannerOnLoadData } from '@cian/adfox-component';
import * as React from 'react';

import { AdfoxNew, IAdfoxNewProps } from '../adfox/adfoxNew';
import { ADFOX_NEW_MEDIA_CONSTANTS } from '../adfox/constants';
import { Marquee } from '../Marquee';
import { TMainpageBrandContext } from '../NewAdfoxBanner/bannerTypes';
import { isLoaderContext, parseAdfoxParams } from '../../utils/adfox';

export type TBrandBannerLoadParams = TMainpageBrandContext;

export interface IBrandBannerProps {
  postViewAnalyticsData: IAdfoxNewProps['postViewAnalyticsData'];
  onLoad?(params: TBrandBannerLoadParams | null): void;
  onStub?(): void;
  marqueeRedesignEnabled?: boolean;
}

export const BrandBanner: React.FC<IBrandBannerProps> = ({
  postViewAnalyticsData,
  onLoad,
  onStub,
  marqueeRedesignEnabled,
}) => {
  const [mediaNote, setMediaNote] = React.useState<string | undefined>(undefined);

  const handleLoad = React.useCallback(
    (data: IAdFoxBannerOnLoadData) => {
      const params = isLoaderContext(data) ? parseAdfoxParams(data) : null;

      setMediaNote(params?.note);

      if (onLoad) {
        onLoad(params);
      }
    },
    [onLoad],
  );

  return (
    <>
      <AdfoxNew
        constants={ADFOX_NEW_MEDIA_CONSTANTS}
        postViewAnalyticsData={postViewAnalyticsData}
        onLoad={handleLoad}
        onStub={onStub}
      />
      <Marquee mediaNote={mediaNote} isRedesignEnabled={marqueeRedesignEnabled} />
    </>
  );
};
